import Awesomplete from 'awesomplete';
import Axios from 'axios';

const Autocomplete = {
  init: function (selector) {
    const autoCompletes = document.querySelectorAll(selector);
    if (autoCompletes && autoCompletes.length) {
      [...autoCompletes].map(item => {
        const dataList = item.getAttribute('data-autocomplete');
        const autocomplete = new Awesomplete(item, { maxItems: 6 });
        Axios.get(dataList)
        .then(function (response) {
          autocomplete.list = response.data;
        });
      });
    }
  }
};

export default Autocomplete;
